<div class="paragraph">
<p>A rich text editor is a text area with added capabilities for writing and editing content, like styling and linking, for use in various publishers.</p>
</div>